import classNames from 'classnames';
import { FC } from 'react';

import { IcSReadDone16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes, PlayIcon, PlayIconType } from '@gem/ui-kit';

import { ChatBackgroundImageSize, ChatBackgroundType } from 'APP/constants/appearance';
import { ChatBackground } from 'APP/main/components/ChatBackground/ChatBackground';
import {
  getChatBackgroundClassName,
  useChatBackgroundClassName,
} from 'APP/main/components/ChatBackground/hooks/useChatBackgroundClassName';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';
import chatBackgroundStyles from 'MAIN/components/ChatBackground/ChatBackground.styles.m.css';

import styles from './AppearanceExample.styles.m.css';
import { HistogramImage } from './HistogramImage/HistogramImage';

interface IAppearanceExampleProps {
  previewBackground?: TChatBackground;
}

export const AppearanceExample: FC<IAppearanceExampleProps> = ({ previewBackground }) => {
  const { t } = useTranslation();
  const defaultChatBackgroundClassName = useChatBackgroundClassName();

  const chatBackgroundClassName =
    previewBackground && previewBackground.type === ChatBackgroundType.Pattern
      ? chatBackgroundStyles[getChatBackgroundClassName(previewBackground.background)]
      : defaultChatBackgroundClassName;

  return (
    <div className={classNames(styles.container, chatBackgroundClassName)}>
      <ChatBackground
        background={previewBackground}
        size={ChatBackgroundImageSize.Preview}
      />

      <div className={styles.content}>
        <div className={classNames(styles.messageBubble, styles.left)}>
          <div className={styles.messageReply}>
            <div className={styles.replyName}>{t('chat_appearance_text_size_stub1')}</div>
            <div className={styles.replyText}>{t('chat_appearance_text_size_stub2')}</div>
          </div>

          <div className={styles.message}>
            <span className={styles.messageText}>{t('chat_appearance_text_size_stub3')}</span>
          </div>
          <span className={styles.messageStatus}>10:15</span>
        </div>

        <div className={classNames(styles.messageBubble, styles.right, styles.shortBubble)}>
          <div className={styles.message}>
            <span className={styles.messageText}>{t('chat_appearance_text_size_stub4')}</span>
          </div>
          <span className={styles.messageStatus}>
            10:15
            <IconView
              className={styles.statusIcon}
              Icon={IcSReadDone16Icon}
              size={IconViewSizes.Small}
            />
          </span>
        </div>

        <div className={classNames(styles.messageBubble, styles.right)}>
          <div className={styles.message}>
            <div className={styles.audioMessage}>
              <PlayIcon
                type={PlayIconType.Play}
                className={styles.playIcon}
                theme="chat"
              />
              <div className={styles.audioHistogram}>
                <HistogramImage className={styles.histogramImage} />
                <span className={styles.audioDuration}>20:23</span>
              </div>
            </div>
          </div>
          <span className={styles.messageStatus}>
            10:15
            <IconView
              className={styles.statusIcon}
              Icon={IcSReadDone16Icon}
              size={IconViewSizes.Small}
            />
          </span>
        </div>
      </div>
    </div>
  );
};
